<!-- 予約/購入内容確認(予約前) -->
<template>
  <TemplateMfittBookingConfirmation v-if="isReadyToDraw" />
  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeoutSeconds="7000" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception
    ref="DialogBadReception"
    :closeButtonClicked="backToPreviousPage"
  />

  <DialogDuringMaintenance
    ref="DialogDuringMaintenance"
    :closeButtonClicked="backToPreviousPage"
  />

  <DialogUnexpectedError
    ref="DialogUnexpectedError"
    :closeButtonClicked="backToPreviousPage"
  />
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import TemplateMfittBookingConfirmation from "@/views/Templates/MFITT/TemplateMfittBookingConfirmation";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MfittBookingConfirmation",
  components: {
    TemplateMfittBookingConfirmation,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      try {
        // チケット値段取得API
        await API.getTicketPrice(route.params.id);
        isReadyToDraw.value = true;
      } catch (e) {
        if (e.response.data.message) {
          if (e.response.data.message === "回線が込み合っています") {
            DialogBadReception.value.openDialog();
            // MWのメンテナンス中
          } else if (e.response.status == 503) {
            DialogDuringMaintenance.value.openDialog(e.response.data);
          } else {
            // nativeにエラー内容送信
            nativeHandlerService.ncSendMfittError(e.response.data.message);
            DialogUnexpectedError.value.openDialog();
          }
        } else {
          nativeHandlerService.ncSendMfittError(
            "MFITTBookingConfirmation onMounted()"
          );
        }
      }
    });

    return {
      isReadyToDraw,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
    };
  },
};
</script>
